import { useEffect } from "react";
import { useLocation } from "react-router-dom"

function ScrollToHash() {
    const location = useLocation();

    useEffect(() => { 
        const { hash } = location;

        if (hash) {
            const element = document.getElementById(hash.replace('#', ''));
            setTimeout(() => {
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 0);
        } else {
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    }, [location]);

    return null;
}

export default ScrollToHash;